import ProductItem from './product/ProductItem';
import { getTranslation, reinitSwymActionButtons } from '../helpers';
import initBuyButtons from '../global/initBuyButtons';

const selectors = {
  productGrid: '#product-grid',
  productItems: '[data-product-item]',
  viewMoreButton: '[data-view-more-button]',
};

class ViewMorePagination extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.button = this.querySelector(selectors.viewMoreButton);
    this.defaultButtonText = this.button?.textContent.trim() || '';
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.button?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    event.preventDefault();

    if (this.loading) {
      return;
    }

    const { nextUrl, sectionId } = this.dataset;

    if (!nextUrl || !sectionId) {
      return;
    }

    this.setLoading(true);

    fetch(this.buildSectionUrl(nextUrl, sectionId))
      .then(response => response.text())
      .then(html => {
        this.appendProducts(html);
        this.updatePagination(html);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  buildSectionUrl(nextUrl, sectionId) {
    const url = nextUrl.startsWith('?')
      ? `${window.location.pathname}${nextUrl}`
      : nextUrl;
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}section_id=${sectionId}`;
  }

  appendProducts(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsedHtml.querySelector(selectors.productGrid);
    const currentGrid = document.querySelector(selectors.productGrid);

    if (!newGrid || !currentGrid) {
      return;
    }

    const newItems = [...newGrid.querySelectorAll(':scope > li')];

    newItems.forEach(item => {
      currentGrid.appendChild(item);
    });

    initBuyButtons(currentGrid);
    reinitSwymActionButtons(currentGrid);
  }

  updatePagination(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const newPagination = parsedHtml.querySelector('view-more-pagination');

    if (newPagination) {
      this.replaceWith(newPagination);
      return;
    }

    this.remove();
  }

  setLoading(isLoading) {
    this.loading = isLoading;
    this.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (!this.button) {
      return;
    }

    this.button.disabled = isLoading;
    this.button.classList.toggle('button--disabled', isLoading);
    this.button.textContent = isLoading
      ? getTranslation('products.loading')
      : this.defaultButtonText;
  }
}

let isDefined = false;

const initViewMorePagination = () => {
  if (isDefined) {
    return;
  }

  customElements.define('view-more-pagination', ViewMorePagination);
  isDefined = true;
};

export default initViewMorePagination;
